import * as React from 'react';
import { useState } from 'react';

import { contactAccessOrAffiliation } from '@components/CandidatesApp/CandidatesShow/components/ContactAccess';
import { Button, Text } from '@components/common';
import { TeamSVG } from '@components/svgs';
import { useFeature } from '@hooks/useFeature';

import { CreateTeamModal } from '../../modals/CreateTeamModal';

export const ZDS: React.FC<React.PropsWithChildren<unknown>> = () => {
  const hasTeamAccessControl = useFeature('team_access_control');
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div>
      <div className='p-12 text-center'>
        <div className='mb-6 flex justify-center text-gray-500'>
          <TeamSVG className='h-20 w-20' />
        </div>
        <Text mb='2' bold>
          Organize research around your Teams
        </Text>
        <Text h='400' color='gray-500' mb='6'>
          Set up Teams of people that regularly work together to organize your studies, and govern candidate{' '}
          {contactAccessOrAffiliation(hasTeamAccessControl).toLowerCase()} by Teams as needed.
        </Text>
        <Button primary small onClick={() => setModalOpen(true)}>
          Create team
        </Button>
      </div>
      <CreateTeamModal trackKey='zds' open={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
};
